import "slick-carousel";
import $ from "jquery";

const init = () => {
  testimonialSlider();
  handleReadMore();
};

const el = {
  main: ".mi-Testimonials",
};

const testimonialSlider = () => {
  $(el.main).slick({
    slidesToShow:3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 0,
    speed: 1000,
    pauseOnHover: false,
    pauseOnFocus: false,
    draggable: false,
    arrows: true,
    dots: false,
      prevArrow: $('.mi-Testi-Prev'),
    nextArrow: $('.mi-Testi-Next'),
    responsive: [
      {
        breakpoint: 1920,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
};

const handleReadMore = () => {
  // Handle "Read more"
  $(".mi-Testimonials-Item-Description-More").on("click", function (e) {
    e.preventDefault();
    const $container = $(this).closest(".mi-Testimonials-Item-Description");
    $container.find(".mi-Testimonials-Item-Description-Short").hide();
    $container.find(".mi-Testimonials-Item-Description-Full").show();
    $(this).hide();
    $container.find(".mi-Testimonials-Item-Description-Less").show();
  });

  // Handle "Read less"
  $(".mi-Testimonials-Item-Description-Less").on("click", function (e) {
    e.preventDefault();
    const $container = $(this).closest(".mi-Testimonials-Item-Description");
    $container.find(".mi-Testimonials-Item-Description-Full").hide();
    $container.find(".mi-Testimonials-Item-Description-Short").show();
    $(this).hide();
    $container.find(".mi-Testimonials-Item-Description-More").show();
  });
};

try {
  init();
} catch (error) {
  console.log(`Error Tesimonial Slider: `, error);
}
